import React from 'react';
import { Section } from './ui/Section';
import { Clock, MessageSquare, Car, Brain, Home, Briefcase } from 'lucide-react';
export function ProductReveal() {
  const scenarios = [{
    icon: Clock,
    label: 'Antes de un meeting'
  }, {
    icon: Briefcase,
    label: 'Al arrancar el shift'
  }, {
    icon: MessageSquare,
    label: 'Entre calls'
  }, {
    icon: Brain,
    label: 'Después de un mensaje que te enciende'
  }, {
    icon: Home,
    label: 'Al salir del trabajo'
  }];
  return <Section className="bg-[#0A0A0A] border-t border-gray-900" data-id="element-224">
      <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-225">
        <p className="text-[#2563EB] font-bold tracking-widest uppercase mb-4" data-id="element-226">
          Solución
        </p>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-4" data-id="element-227">
          Presento: <span className="text-[#2563EB]" data-id="element-228">Reset Operativo</span> (7
          Min)
        </h2>
        <p className="text-xl text-gray-400 mb-2" data-id="element-229">
          Protocolo Anti-Estrés para Hombres Ocupados (Hispanos USA)
        </p>
        <p className="text-sm text-gray-600 font-medium" data-id="element-230">
          por Reset Mental Funcional (RMF)
        </p>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-231">
        <div className="bg-[#111111] border border-gray-800 rounded-3xl p-8 md:p-12 mb-12" data-id="element-232">
          <p className="text-2xl text-white font-medium text-center mb-10" data-id="element-233">
            Un PDF práctico (cero místico) con un sistema que puedes usar:
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-234">
            {scenarios.map((scenario, i) => <div key={i} className="flex flex-col items-center text-center p-4 bg-[#1A1A1A] rounded-xl border border-gray-800 hover:border-[#2563EB]/50 transition-colors group" data-id="element-235">
                <scenario.icon className="w-8 h-8 text-gray-500 group-hover:text-[#2563EB] mb-3 transition-colors" data-id="element-236" />
                <span className="text-sm text-gray-300 font-medium leading-tight" data-id="element-237">
                  {scenario.label}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-238">
          <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-239">
            La diferencia: no son “tips”.{' '}
            <span className="text-[#2563EB] underline decoration-4 decoration-[#2563EB]/30 underline-offset-4" data-id="element-240">
              Es un mecanismo.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}